/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-07-06 16:13:01
 * @LastEditTime: 2020-07-27 18:54:15
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/router/permission.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import router from "./";
import { getToken,getOIDCToken } from "@/utils/auth";
import { loadingStart, loadingFinish } from "@/utils/loading";
import request from "@/utils/request";
import { setStore,clearStore } from '@/utils/store';
import common from '@/utils/common';

//  获取url参数  以#截取
function urlParams(url) {
  let indexStart = url.indexOf('#')
  if (indexStart == -1) { return {} }
  let k = url.slice(indexStart + 1);
  if (k.charAt(0) == '/') {
    k = k.slice(1);
  }
  let x = k.replace(/&/g, '","').replace(/=/g, '":"');
  let y = '{"' + x + '"}'
  return JSON.parse(y)

}

router.beforeEach((to, from, next) => {
  loadingStart();
  const meta = to.meta || {};
  //alert(to.path + ' ' + to.name);
  if (to.path.indexOf("access_token") > -1) {
    //next();
    //return false;
    let params = urlParams(window.location.href);
    let url1 = "/api/v1/sso/login?accessToken=" + params.access_token;
    setStore({ name: 'OIDCToken', content: params.id_token, type: true });
    console.log(url1);
    request({
      url: url1,
      method: "GET"
    }).then((res) => {
      console.log(res)
      debugger;
      //if (res.errcode == 0) {
      //}
  
      setStore({ name: 'unionToken', content: res.accessToken, type: true });
      setStore({ name: 'monkey', content: res.monkey, type: true });
      common.monkey = res.monkey;
      getAuthority();
    }
    ).catch((error) => {
     
      if (error.status == '400') {
        this.$message.error(error.data.error.message)
      }
      if (error.status == '401') {
        this.$message.error(this.$t('login.error_pass'))
        
      }
      //next('/login');

    });

    return false;
  } else if (to.path == "/login" || to.name == "login") {
    request({
      url: "/api/v1/sso/getConfig",
      method: "GET"
    }).then((res) => {
      console.log(res)
      debugger;
      //if (res.errcode == 0) {
      // setStore({ name: 'base_url', content: res.base_url, type: true });
      // setStore({ name: 'realm_path', content: res.realm_path, type: true });
      // setStore({ name: 'logout_redirect_uri', content: res.logout_redirect_uri, type: true });
      if(getOIDCToken()){
        let oidctoken = getOIDCToken();
        clearStore({ type: true })
        let url2=res.base_url+"oauth2"+res.realm_path+"/connect/endSession?id_token_hint="+oidctoken+"&post_logout_redirect_uri="+res.logout_redirect_uri;
        window.location.href = url2;
      }
      else{
        let url = `${res.base_url}oauth2${res.realm_path}/authorize?client_id=${res.client_id}&state=${res.state}&scope=${res.scope}&redirect_uri=${res.redirect_uri}&response_type=${res.response_type}&nonce=${res.nonce}`;
        //setStore({ name: 'OIDCClient', content: res.client_id, type: true });
        window.location.href = url;
      }
      // let base_url = getStore({ name: "base_url", type: true });
      // let realm_path = getStore({ name: "realm_path", type: true });
      // let logout_redirect_uri = getStore({ name: "logout_redirect_uri", type: true });
     
      
      //}
    }
    );
    return false;
  }
  if (getToken()) {
    //alert('333');
    console.log('333')
    next();
  } else {
    if (meta.isAuth === false) {
      console.log('444')
      //alert('444');
      next();
    } else {
      //alert('555');
      meta.isAuth = false;
      console.log("4434");
      next('/login');
      //next();
    }
  }
});

function getAuthority() {
  request({
    url: "/api/v1/mine/menus",
    method: "GET"
  }).then((res) => {
    console.log(res.menus)

    for (let i = 0; i < res.menus.length; i++) {
      if (res.menus[i].childs.length == 0) {
        delete res.menus[i].childs;
      } else {
        setStore({ name: 'route_parent', content: res.menus[i].name + '/' + res.menus[i].childs[0].name, type: true })
        setStore({ name: 'templateId', content: res.menus[i].childs[0].templateId, type: true })
        break;
      }
    }
    //进行页面的跳转
    if (res.menus.length !== 0) {
      for (let i = 0; i < res.menus.length; i++) {
        if (res.menus[i].childs && res.menus[i].childs.length !== 0) {
          let route = res.menus[i].childs[0].route;
          //router.push(route);
          router.push({
            path: route
          })
          break;
        }
      }
    }
  })
}


router.afterEach(() => {
  loadingFinish();
});



// WEBPACK FOOTER //
// ./src/router/permission.js